(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	var comments = $('#comments');
	var postComment = $('#post-comment');
	var nav = $('#social-media-buttons');

	// Collapse postComment if there are no comments
	if (!comments.length) {
		postComment.addClass('collapsed');

		nav.find('a[href="#post-comment"]')
			.click(function (e) {
				e.preventDefault();
				postComment.removeClass('collapsed');
			});
	}
})();
